export default "__VITE_PUBLIC_ASSET__7b7b1696__"